import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { useTheme as useCustomTheme } from "../context/ThemeContext";
import { useLanguage } from "../context/LanguageContext";

const ThemeToggle = ({ size = "medium", ...props }) => {
  const theme = useTheme();
  const { mode, toggleTheme } = useCustomTheme();
  const { t } = useLanguage();

  return (
    <Tooltip
      title={
        mode === "dark"
          ? t("darkModeEnabled")
          : t("lightModeEnabled") || "Toggle theme"
      }
    >
      <IconButton
        color="inherit"
        size={size}
        aria-label={t("toggleTheme") || "Toggle theme"}
        onClick={toggleTheme}
        sx={{
          position: "relative",
          overflow: "hidden",
          cursor: "pointer",
          opacity: 1,
          ...props.sx,
        }}
        {...props}
      >
        {mode === "dark" ? (
          <DarkModeIcon fontSize={size} sx={{ color: "primary.light" }} />
        ) : (
          <LightModeIcon fontSize={size} sx={{ color: "warning.main" }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
